/* eslint-disable sort-keys */
// TODO import { largeMax, largeMin, mediumMax, mediumMin, smallMax, xlargeMin } from '.../mediaQueries.module.scss';
// TODO should these defines be CAP_UNDERSCORE?
export const deviceSizes = {
  small: 320,
  medium: 768,
  large: 1136,
  xLarge: 1392,
};
